export const GET_SINGLE_FOOD_REPORT_START = "GET_SINGLE_FOOD_REPORT_START";
export const GET_SINGLE_FOOD_REPORT_SUCCESS = "GET_SINGLE_FOOD_REPORT_SUCCESS";
export const GET_SINGLE_FOOD_REPORT_FAILURE = "GET_SINGLE_FOOD_REPORT_FAILURE";
export const GET_CFOOD_TOTAL_EXPENSE_REPORT = "GET_CFOOD_TOTAL_EXPENSE_REPORT";
export const GET_CFOOD_TOTAL_EXPENSE_REPORT_FAILURE =
  "GET_CFOOD_TOTAL_EXPENSE_REPORT_FAILURE";

export const SET_FROM_TIME = "SET_FROM_TIME";
export const SET_TO_TIME = "SET_TO_TIME";

export const REMOVE_TO_TIME = "REMOVE_TO_TIME";
export const REMOVE_FROM_TIME = "REMOVE_FROM_TIME";

export const SET_REPORT_BY_ENGLISH_SELECT = "SET_REPORT_BY_ENGLISH_SELECT";
export const UNSET_REPORT_BY_ENGLISH_SELECT = "UNSET_REPORT_BY_ENGLISH_SELECT";
export const SET_REPORT_BY_NEPALI_DATE = "SET_REPORT_BY_NEPALI_DATE";
export const UNSET_REPORT_BY_NEPALI_DATE = "UNSET_REPORT_BY_NEPALI_DATE";
export const SET_REPORT_BY_ENGLISH_DATE = "SET_REPORT_BY_ENGLISH_DATE";
export const UNSET_REPORT_BY_ENGLISH_DATE = "UNSET_REPORT_BY_ENGLISH_DATE";

export const SET_ALL_REPORT_BY_FALSE = "SET_ALL_REPORT_BY_FALSE";
